export const Icons = {
  Instagram: {
    active: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clip-path="url(#clip0_3026_2670)">
          <path
            d="M22.467 0H9.53297C4.27647 0 0 4.27647 0 9.53297V22.467C0 27.7235 4.27647 32 9.53297 32H22.467C27.7235 32 32 27.7235 32 22.467V9.53297C31.9999 4.27647 27.7235 0 22.467 0ZM28.7808 22.467C28.7808 25.954 25.954 28.7808 22.467 28.7808H9.53297C6.046 28.7808 3.2192 25.954 3.2192 22.467V9.53297C3.2192 6.04594 6.046 3.2192 9.53297 3.2192H22.467C25.954 3.2192 28.7808 6.04594 28.7808 9.53297V22.467Z"
            fill="url(#paint0_linear_3026_2670)"
          />
          <path
            d="M16 7.72366C11.4364 7.72366 7.72363 11.4364 7.72363 15.9999C7.72363 20.5635 11.4364 24.2763 16 24.2763C20.5636 24.2763 24.2763 20.5635 24.2763 15.9999C24.2763 11.4364 20.5636 7.72366 16 7.72366ZM16 21.0571C13.207 21.0571 10.9428 18.793 10.9428 16C10.9428 13.207 13.207 10.9429 16 10.9429C18.793 10.9429 21.0571 13.207 21.0571 16C21.0571 18.7929 18.7929 21.0571 16 21.0571Z"
            fill="url(#paint1_linear_3026_2670)"
          />
          <path
            d="M24.2923 9.76898C25.3875 9.76898 26.2754 8.88108 26.2754 7.7858C26.2754 6.69052 25.3875 5.80262 24.2923 5.80262C23.197 5.80262 22.3091 6.69052 22.3091 7.7858C22.3091 8.88108 23.197 9.76898 24.2923 9.76898Z"
            fill="url(#paint2_linear_3026_2670)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_3026_2670"
            x1="16"
            y1="31.9069"
            x2="16"
            y2="0.248549"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E09B3D" />
            <stop offset="0.3" stop-color="#C74C4D" />
            <stop offset="0.6" stop-color="#C21975" />
            <stop offset="1" stop-color="#7024C4" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3026_2670"
            x1="16"
            y1="31.9069"
            x2="16"
            y2="0.248554"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E09B3D" />
            <stop offset="0.3" stop-color="#C74C4D" />
            <stop offset="0.6" stop-color="#C21975" />
            <stop offset="1" stop-color="#7024C4" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3026_2670"
            x1="24.2923"
            y1="31.9069"
            x2="24.2923"
            y2="0.248553"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#E09B3D" />
            <stop offset="0.3" stop-color="#C74C4D" />
            <stop offset="0.6" stop-color="#C21975" />
            <stop offset="1" stop-color="#7024C4" />
          </linearGradient>
          <clipPath id="clip0_3026_2670">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    inactive: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 33"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_19901)">
          <path
            d="M22.467 0.5H9.53297C4.27647 0.5 0 4.77647 0 10.033V22.967C0 28.2235 4.27647 32.5 9.53297 32.5H22.467C27.7235 32.5 32 28.2235 32 22.967V10.033C31.9999 4.77647 27.7235 0.5 22.467 0.5ZM28.7808 22.967C28.7808 26.454 25.954 29.2808 22.467 29.2808H9.53297C6.046 29.2808 3.2192 26.454 3.2192 22.967V10.033C3.2192 6.54594 6.046 3.7192 9.53297 3.7192H22.467C25.954 3.7192 28.7808 6.54594 28.7808 10.033V22.967Z"
            fill="#909090"
          />
          <path
            d="M16 8.22363C11.4364 8.22363 7.72363 11.9364 7.72363 16.4999C7.72363 21.0634 11.4364 24.7763 16 24.7763C20.5636 24.7763 24.2763 21.0635 24.2763 16.4999C24.2763 11.9363 20.5636 8.22363 16 8.22363ZM16 21.5571C13.207 21.5571 10.9428 19.293 10.9428 16.5C10.9428 13.707 13.207 11.4428 16 11.4428C18.793 11.4428 21.0571 13.707 21.0571 16.5C21.0571 19.2929 18.7929 21.5571 16 21.5571Z"
            fill="#909090"
          />
          <path
            d="M24.2923 10.269C25.3875 10.269 26.2754 9.38107 26.2754 8.28579C26.2754 7.19051 25.3875 6.30261 24.2923 6.30261C23.197 6.30261 22.3091 7.19051 22.3091 8.28579C22.3091 9.38107 23.197 10.269 24.2923 10.269Z"
            fill="#909090"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_19901">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  },
  Facebook: {
    active: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_20231)">
          <path
            d="M27.2 0H4.8C2.14903 0 0 2.14903 0 4.8V27.2C0 29.851 2.14903 32 4.8 32H27.2C29.851 32 32 29.851 32 27.2V4.8C32 2.14903 29.851 0 27.2 0Z"
            fill="#1877F2"
          />
          <path
            d="M17.9375 28.5V9.8125C17.9375 8.5 18.3125 7.625 20.125 7.625H22.5V3.6875C22.0625 3.625 20.6875 3.5 19.0625 3.5C15.6875 3.5 13.375 5.5625 13.375 9.375V28.5M22.3125 12.625H9.5V17.125H21.75"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_20231">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    inactive: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 33"
        fill="none"
      >
        <g clip-path="url(#clip0_3026_1884)">
          <path
            d="M27.2 0.5H4.8C2.14903 0.5 0 2.64903 0 5.3V27.7C0 30.351 2.14903 32.5 4.8 32.5H27.2C29.851 32.5 32 30.351 32 27.7V5.3C32 2.64903 29.851 0.5 27.2 0.5Z"
            fill="#909090"
          />
          <path
            d="M17.9375 29V10.3125C17.9375 9 18.3125 8.125 20.125 8.125H22.5V4.1875C22.0625 4.125 20.6875 4 19.0625 4C15.6875 4 13.375 6.0625 13.375 9.875V29M22.3125 13.125H9.5V17.625H21.75"
            fill="#1E1E1E"
          />
        </g>
        <defs>
          <clipPath id="clip0_3026_1884">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    )
  },
  "Tik Tok": {
    active: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_20074)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 32H32V0H0V32Z"
            fill="black"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.0798 4.88001C19.9731 4.42667 19.8931 3.94667 19.8931 3.46667H15.8931V11.4667V12.7733V19.6267C15.8931 21.4933 14.2931 23.0133 12.4265 23.0133C10.5598 23.0133 9.06647 21.52 9.06647 19.6533C9.06647 17.7867 10.5865 16.2667 12.4531 16.2667C12.8265 16.2667 13.1731 16.32 13.5198 16.4267V12.08C13.1731 12.0267 12.8265 12 12.4531 12C8.21314 12 4.7998 15.4133 4.7998 19.6533C4.7998 23.8667 8.21314 27.3067 12.4531 27.3067C16.6131 27.3067 20.0798 23.9733 20.1865 19.84V19.6533V11.5467C21.7598 12.6133 23.5731 13.2533 25.5998 13.2533V9.14667C22.9598 9.14667 20.7198 7.33334 20.0798 4.88001Z"
            fill="#25F4EE"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.4133 6.21332C21.3066 5.75999 21.2266 5.27999 21.2266 4.79999H17.2266V12.8V14.1067V20.96C17.2266 22.8267 15.6266 24.3467 13.76 24.3467C11.8933 24.3467 10.4 22.8533 10.4 20.9867C10.4 19.12 11.92 17.6 13.7866 17.6C14.16 17.6 14.5066 17.6533 14.8533 17.76V13.4133C14.5066 13.36 14.16 13.3333 13.7866 13.3333C9.54663 13.3333 6.1333 16.7467 6.1333 20.9867C6.1333 25.2 9.54663 28.64 13.7866 28.64C17.9466 28.64 21.4133 25.3067 21.52 21.1733V20.9867V12.88C23.0933 13.9467 24.9066 14.5867 26.9333 14.5867V10.48C24.2933 10.48 22.0533 8.66665 21.4133 6.21332Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.0803 4.79999C20.0803 4.82665 20.1069 4.85332 20.1069 4.87999C20.4536 6.18665 21.2536 7.33332 22.3203 8.10665C21.9203 7.54665 21.6269 6.90665 21.4403 6.21332C21.3336 5.75999 21.2536 5.27999 21.2536 4.79999H20.0803ZM25.6003 10.32V13.2267C23.5469 13.2267 21.7603 12.5867 20.1869 11.52V19.6267V19.8133C20.0803 23.9467 16.6136 27.28 12.4536 27.28C10.6936 27.28 9.04025 26.6667 7.76025 25.68C9.14692 27.4667 11.3336 28.6133 13.7869 28.6133C17.9469 28.6133 21.4136 25.28 21.5203 21.1467V20.96V12.88C23.0936 13.9467 24.9069 14.5867 26.9336 14.5867V10.48C26.4803 10.48 26.0269 10.4267 25.6003 10.32ZM13.5203 13.3333V16.4267C13.1736 16.32 12.8269 16.2667 12.4536 16.2667C10.5869 16.2667 9.06692 17.7867 9.06692 19.6533C9.06692 20.9333 9.78692 22.0267 10.8269 22.6133C10.5603 22.1333 10.4003 21.5733 10.4003 20.9867C10.4003 19.12 11.9203 17.6 13.7869 17.6C14.1603 17.6 14.5069 17.6533 14.8536 17.76V13.4133C14.5069 13.36 14.1603 13.3333 13.7869 13.3333C13.6803 13.3333 13.6003 13.3333 13.5203 13.3333Z"
            fill="#FE2C55"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_20074">
            <rect width="32" height="32" rx="4.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    inactive: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 33"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_20086)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 32.5H32V0.5H0V32.5Z"
            fill="#909090"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.0798 5.38001C19.9731 4.92667 19.8931 4.44667 19.8931 3.96667H15.8931V11.9667V13.2733V20.1267C15.8931 21.9933 14.2931 23.5133 12.4265 23.5133C10.5598 23.5133 9.06647 22.02 9.06647 20.1533C9.06647 18.2867 10.5865 16.7667 12.4531 16.7667C12.8265 16.7667 13.1731 16.82 13.5198 16.9267V12.58C13.1731 12.5267 12.8265 12.5 12.4531 12.5C8.21314 12.5 4.7998 15.9133 4.7998 20.1533C4.7998 24.3667 8.21314 27.8067 12.4531 27.8067C16.6131 27.8067 20.0798 24.4733 20.1865 20.34V20.1533V12.0467C21.7598 13.1133 23.5731 13.7533 25.5998 13.7533V9.64667C22.9598 9.64667 20.7198 7.83334 20.0798 5.38001Z"
            fill="#1E1E1E"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.4133 6.71332C21.3066 6.25999 21.2266 5.77999 21.2266 5.29999H17.2266V13.3V14.6067V21.46C17.2266 23.3267 15.6266 24.8467 13.76 24.8467C11.8933 24.8467 10.4 23.3533 10.4 21.4867C10.4 19.62 11.92 18.1 13.7866 18.1C14.16 18.1 14.5066 18.1533 14.8533 18.26V13.9133C14.5066 13.86 14.16 13.8333 13.7866 13.8333C9.54663 13.8333 6.1333 17.2467 6.1333 21.4867C6.1333 25.7 9.54663 29.14 13.7866 29.14C17.9466 29.14 21.4133 25.8067 21.52 21.6733V21.4867V13.38C23.0933 14.4467 24.9066 15.0867 26.9333 15.0867V10.98C24.2933 10.98 22.0533 9.16665 21.4133 6.71332Z"
            fill="#1E1E1E"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.0803 5.29999C20.0803 5.32665 20.1069 5.35332 20.1069 5.37999C20.4536 6.68665 21.2536 7.83332 22.3203 8.60665C21.9203 8.04665 21.6269 7.40665 21.4403 6.71332C21.3336 6.25999 21.2536 5.77999 21.2536 5.29999H20.0803ZM25.6003 10.82V13.7267C23.5469 13.7267 21.7603 13.0867 20.1869 12.02V20.1267V20.3133C20.0803 24.4467 16.6136 27.78 12.4536 27.78C10.6936 27.78 9.04025 27.1667 7.76025 26.18C9.14692 27.9667 11.3336 29.1133 13.7869 29.1133C17.9469 29.1133 21.4136 25.78 21.5203 21.6467V21.46V13.38C23.0936 14.4467 24.9069 15.0867 26.9336 15.0867V10.98C26.4803 10.98 26.0269 10.9267 25.6003 10.82ZM13.5203 13.8333V16.9267C13.1736 16.82 12.8269 16.7667 12.4536 16.7667C10.5869 16.7667 9.06692 18.2867 9.06692 20.1533C9.06692 21.4333 9.78692 22.5267 10.8269 23.1133C10.5603 22.6333 10.4003 22.0733 10.4003 21.4867C10.4003 19.62 11.9203 18.1 13.7869 18.1C14.1603 18.1 14.5069 18.1533 14.8536 18.26V13.9133C14.5069 13.86 14.1603 13.8333 13.7869 13.8333C13.6803 13.8333 13.6003 13.8333 13.5203 13.8333Z"
            fill="#1E1E1E"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_20086">
            <rect y="0.5" width="32" height="32" rx="4.8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  },
  X: {
    active: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_20420)">
          <path d="M0 0H32V32H0" fill="black" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25 24.6039L17.9609 14.344L17.9729 14.3536L24.3197 7H22.1988L17.0285 12.9853L12.9226 7H7.36015L13.9319 16.5789L13.9311 16.5781L7 24.6039H9.12094L14.8691 17.9448L19.4375 24.6039H25ZM12.0822 8.60035L21.9586 23.0036H20.2779L10.3935 8.60035H12.0822Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_20420">
            <rect width="32" height="32" rx="5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    inactive: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 32 33"
        fill="none"
      >
        <g clip-path="url(#clip0_2869_20424)">
          <path d="M0 0.5H32V32.5H0" fill="#909090" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25 25.1039L17.9609 14.844L17.9729 14.8536L24.3197 7.5H22.1988L17.0285 13.4853L12.9226 7.5H7.36015L13.9319 17.0789L13.9311 17.0781L7 25.1039H9.12094L14.8691 18.4448L19.4375 25.1039H25ZM12.0822 9.10035L21.9586 23.5036H20.2779L10.3935 9.10035H12.0822Z"
            fill="#1E1E1E"
          />
        </g>
        <defs>
          <clipPath id="clip0_2869_20424">
            <rect y="0.5" width="32" height="32" rx="5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }
};

export type PlatformType = typeof Icons;
